import store from 'store2'

export const { session, local } = store.namespace('ls')
